module.exports = StyledComponents;